import { Dropdown } from "./Form/Dropdown";
import { CartManager } from "../Modules/Cart/CartManager";
import { Product } from "../Modules/Product";

/**
 * Logic to handle the selection of variants on the PDP
 */
export class ProductVariantSelect {
    public static PRICE_AMOUNT_SELECTOR = "section.price .amount";
    private variantSelectElement: Dropdown;
    private product: Product;

    /**
     * Init new variant-select handler
     * @param variantSelectElement the element on PDP (dropdown)
     */
    constructor(variantSelectElement: Dropdown) {
        this.variantSelectElement = variantSelectElement;
        this.product = new Product(variantSelectElement.dataset.productHandle);
        this.addChangeListener();
    }

    /**
     * Attach change listener to variant dropdown
     * @private
     */
    private addChangeListener(): void {
        this.variantSelectElement.addEventListener("change", this.handleChange.bind(this));
    }

    /**
     * Handler for change events of the variantSelectElement
     * @param event
     * @private
     */
    private handleChange(event: Event): void {
        // The snippet for this script (product-variant-select) uses the variant as option values
        const variantID = (<Dropdown>event.currentTarget).value;
        this.addToCartVariant = variantID;
        this.price = this.product.getVariant(parseInt(variantID)).price;
    }

    /**
     * Update variant dataset of add-to-cart button
     * @param variantId
     * @private
     */
    private set addToCartVariant(variantId: string) {
        document.querySelector<HTMLElement>(CartManager.SELECTORS.ADD).dataset.variant = variantId;
    }

    private set price(price: number) {
        // Prices are stored as integers
        document.querySelector<HTMLElement>(ProductVariantSelect.PRICE_AMOUNT_SELECTOR).innerHTML = String(price / 100);
    }
}
